import { createReducer, on } from '@ngrx/store';
import {
  PlatformConfig,
  PaymentGateway,
  PlatformNameEnum,
} from '@app/configs/geokTheme';
import { setPlatformConfigSuccess } from '@app/shared/store/platform-config/platform-config-actions';

export const platformConfigKey = 'platformConfig';

export interface PlatformConfigState {
  platformConfig: PlatformConfig;
}

export const initialState: PlatformConfigState = {
  platformConfig: {
    paymentGateway: PaymentGateway.UPG,
    platformNameAr: '',
    platformNameEn: '',
    platform: PlatformNameEnum.SPL,
  },
};
export const PlatformConfigReducer = createReducer(
  initialState,
  on(setPlatformConfigSuccess, (state, { platformConfig }) => ({
    ...state,
    platformConfig: platformConfig,
  }))
);
